/**
 * Real KittyPot app screenshots used across the marketing site.
 *
 * These are genuine product screens — do not restyle or recreate the app UI in
 * markup. Alt text describes what each screen actually shows.
 */

export type AppScreen = {
  src: string
  alt: string
}

export const screens = {
  kittyMain: {
    src: 'https://cdn.magicpatterns.com/uploads/b93TEZRoyohfyrct1nQCK7/i.jpg',
    alt: 'KittyPot app showing the Weekend away kitty with £951.78 total spent, six members, and a form to add an expense with amount, split with, paid by and paid for',
  },
  addExpense: {
    src: 'https://cdn.magicpatterns.com/uploads/xtbSxYu4ABHAJFh9YHZMBg/t.jpg',
    alt: 'KittyPot Ski Trip kitty with an expense being added: €50.00 for drinks, split with eight people and paid by Steph, with Add expense and Add receipt buttons',
  },
  myBalance: {
    src: 'https://cdn.magicpatterns.com/uploads/dLLmZN5F1H57oybUnJahVx/y.jpg',
    alt: "KittyPot My Balance screen showing £1,064.88 owed overall, £1,180.62 you're owed and £115.74 you owe, with each kitty listed one by one",
  },
  webJoin: {
    src: 'https://cdn.magicpatterns.com/uploads/u1NEfuQwBAqSzkBEnQ79m7/Web_join.jpg',
    alt: 'A phone browser at join.kittypot.com showing an invitation to the Weekend away kitty and a list of names to choose from',
  },
  createKitty: {
    src: 'https://cdn.magicpatterns.com/uploads/5Q5GNgeBBv1rhL6mWwCTg2/w.jpg',
    alt: 'KittyPot Name Kitty screen with GBP selected as the kitty currency, six members added (Steph, Will, Soph, El, Ben and Dan), an option to add someone by name and a Create Kitty button',
  },
  shareQr: {
    src: 'https://cdn.magicpatterns.com/uploads/gqgYmikKMuv37kq2oo7wC7/e.jpg',
    alt: 'KittyPot share screen showing the Weekend Away kitty with the join reference RWLA-O6M6 and a QR code',
  },
  breakdown: {
    src: 'https://cdn.magicpatterns.com/uploads/ikui1Txe9BEqGeakWga7yp/r.jpg',
    alt: 'KittyPot Breakdown screen showing Ed owes you £147.29 across four expenses, grouped by date, including entry tickets, pints and drinks, with Mark as paid, Send nudge and Share breakdown buttons',
  },
  paymentRequest: {
    src: 'https://cdn.magicpatterns.com/uploads/4XUCqh2nfVPv3zEywQuEhZ/zxczc.jpg',
    alt: 'A messaging app showing a KittyPot payment request from Bobby to Will for €99.22, with an itemised breakdown and bank details to pay outside KittyPot',
  },
  spinner: {
    src: 'https://cdn.magicpatterns.com/uploads/eQFmFwkDRaM5U67B8HEVdV/rtgrt.jpg',
    alt: "KittyPot's Whose round is next? screen showing a colourful spinning wheel with six names on it",
  },
  history: {
    src: 'https://cdn.magicpatterns.com/uploads/n2KBGAoL2hxxJBE6WjNvMr/u.jpg',
    alt: 'KittyPot Settlement history showing £951.78 total spent across six expenses, grouped by date, with who paid each one and attached receipts',
  },
} satisfies Record<string, AppScreen>
